module.exports = __webpack_public_path__ + "media/images/squared-5-b0d32b520eda39ac9c377bf3358e95b2.png";